import { StepperSelectionEvent, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe, formatDate } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MatLegacyDialogState as MatDialogState, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatStepper } from '@angular/material/stepper';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, combineLatest, firstValueFrom, merge, Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, first, map, shareReplay, startWith, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { EntityRoleSlugEnum } from 'src/app/dave-data-module/entities/entity-role.entity';
import { getEmployeesSortedByNameStartWithMe } from 'src/app/dave-data-module/State/selectors/employees.selectors';
import { getEntityRole } from 'src/app/dave-data-module/State/selectors/entity-role.selector';
import { getUserToCommissions } from 'src/app/dave-data-module/State/selectors/user-to-commission.selector';
import { getUser, getUserById } from 'src/app/dave-data-module/State/selectors/users.selectors';
import { AddReportService } from '../../../../add-report-button/add-report.service';
import { CommissionEntity } from '../../../../dave-data-module/entities/commission.entity';
import { ConstructionDiaryEntity, ConstructionDiaryEntityAdditionalData, ConstructionDiaryStatusEnum, ConstructionDiaryStatusEnumNameMap } from '../../../../dave-data-module/entities/construction-diary.entity';
import { EventTypeNamesEnum } from '../../../../dave-data-module/entities/event-type.entity';
import { EventEntity, EventStateEnum, EventStateEnumNameMap, MapMarker, MapMarkerFileDictionary } from '../../../../dave-data-module/entities/event.entity';
import { FileEntity, FileMetaData } from '../../../../dave-data-module/entities/file.entity';
import { FolderEntity, FolderTypes } from '../../../../dave-data-module/entities/folder.entity';
import { GeneratedDocumentsEntity, GeneratedDocumentsEntityAdditionalData } from '../../../../dave-data-module/entities/generatedDocuments.entity';
import { GeneratedDocumentsTypeSlugs } from '../../../../dave-data-module/entities/generatedDocumentsType.entity';
import { PartnerTypeEnum } from '../../../../dave-data-module/entities/partner.entity';
import { DaveMutationCreateConstructionDiaryArgs } from '../../../../dave-data-module/graphql-types';
import { CommissionResolver } from '../../../../dave-data-module/guards/commission.resolver';
import { CommissionTypeResolver } from '../../../../dave-data-module/guards/commissionType.resolver';
import { ComplaintTypeResolver } from '../../../../dave-data-module/guards/complaintType.resolver';
import {
    ConstructionDiaryByCommissionIdResolverWithoutRoute,
} from '../../../../dave-data-module/guards/construction-diary.resolver';
import { EventTypeResolver } from '../../../../dave-data-module/guards/event-type.resolver';
import { EventResolver } from '../../../../dave-data-module/guards/event.resolver';
import { GeneratedDocumentsResolver } from '../../../../dave-data-module/guards/generatedDocuments.resolver';
import { GeneratedDocumentsTypeResolver } from '../../../../dave-data-module/guards/generatedDocumentsType.resolver';
import { ComponentCanDeactivate, PENDING_CHANGES_DEFAULT_MESSAGE } from '../../../../dave-data-module/guards/pending-changes.guard';
import { PersonResolver } from '../../../../dave-data-module/guards/person.resolver';
import { Person2EntityResolver } from '../../../../dave-data-module/guards/person2Entity.resolver';
import { StatusFromBackofficeResolver } from '../../../../dave-data-module/guards/statusFromBackoffice.resolver';
import { TravelZoneResolver } from '../../../../dave-data-module/guards/travel-zone.resolver';
import { WorkDayResolver } from '../../../../dave-data-module/guards/work-day.resolver';
import { WorkedTimesResolver } from '../../../../dave-data-module/guards/worked-times.resolver';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { ConstructionDiaryDataService, DailyTaskType } from '../../../../dave-data-module/services/construction-diary-data.service';
import { FileDataService } from '../../../../dave-data-module/services/file-data.service';
import { FolderDataService } from '../../../../dave-data-module/services/folder-data.service';
import { State } from '../../../../dave-data-module/State';
import { BaseActionTypes } from '../../../../dave-data-module/State/actions/base.actions';
import { CommissionActionTypes } from '../../../../dave-data-module/State/actions/commission.actions';
import { ConstructionDiaryActionTypes } from '../../../../dave-data-module/State/actions/construction-diary.actions';
import { EventsActionTypes } from '../../../../dave-data-module/State/actions/events.actions';
import { FilesActionTypes, FileUploadParams, fileUploadParamsObj } from '../../../../dave-data-module/State/actions/files.actions';
import { GeneratedDocumentsActionTypes } from '../../../../dave-data-module/State/actions/generatedDocuments.actions';
import { getCommissionById, getCommissionDictionary, getCommissions, getCommissionsFetched } from '../../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypes, getCommissionTypesFetched } from '../../../../dave-data-module/State/selectors/commissionType.selectors';
import { getEventTypes } from '../../../../dave-data-module/State/selectors/event-type.selector';
import { getFiles } from '../../../../dave-data-module/State/selectors/files.selectors';
import { getFolderByEntity } from '../../../../dave-data-module/State/selectors/folder.selectors';
import { getGeneratedDocumentById, getGeneratedDocuments, getGeneratedDocumentsFetched } from '../../../../dave-data-module/State/selectors/generatedDocuments.selectors';
import { getGeneratedDocumentsTypes, getGeneratedDocumentsTypesFetched } from '../../../../dave-data-module/State/selectors/generatedDocumentsType.selectors';
import { getPartner } from '../../../../dave-data-module/State/selectors/partners.selectors';
import { getPersonDictionary, getPersonsFetched } from '../../../../dave-data-module/State/selectors/person.selectors';
import { getPerson2EntitiesFetched, getPerson2EntityByCommissionId } from '../../../../dave-data-module/State/selectors/person2entity.selectors';
import { DocumentEditorDialogComponent, DocumentEditorDialogComponentCloseData, DocumentEditorDialogComponentDialogData } from '../../../../dave-document-editor-module/components/document-editor-dialog/document-editor-dialog.component';
import { DaveFilePreviewComponent, DaveFilePreviewComponentDialogData } from '../../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import { ButtonConfig, DaveListCardcolumnProperties } from '../../../../dave-list-card/dave-list-card.component';
import { SelectPersonsComponent, SelectPersonsComponentDialogData, SelectPersonsComponentDialogReturnData } from '../../../../dave-person-module/components/select-persons/select-persons.component';
import {
    DaveSelectFileFromDmsComponent,
    DaveSelectFileFromDmsComponentDialogData,
    DaveSelectFileFromDmsComponentReturnData,
} from '../../../../dave-select-file-from-dms/components/dave-select-file-from-dms/dave-select-file-from-dms.component';
import { appMatDialogDefaultConfig, isNotNullOrUndefined, PLAN_FILE_PREFIX_FOR_SFDT_TEMPLATES, sameDay, uniqArray } from '../../../../helper/helper';
import { DMSPageMeta, GeneratedDocumentsPageMeta, UserAdministrationMeta } from '../../../../helper/page-metadata';
import { CustomLabelService } from '../../../../services/custom-label/custom-label.service';
import { LoadingService } from '../../../../services/loading.service';
import { ShowImageComponent, ShowImageComponentDialogData } from '../../show-image/show-image.component';
import { AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn } from '../add-event-dialog/add-event-dialog.component';
import { SelectDiaryTimespanDialogComponent, SelectDiaryTimespanDialogComponentDialogData, SelectDiaryTimespanDialogComponentDialogReturnData } from '../select-diary-timespan-dialog/select-diary-timespan-dialog.component';
import { createMaterialDeviceForm, materialDeviceForm } from './construction-diary-material-device-list/construction-diary-material-device-list.component';
import { HttpService } from 'src/app/dave-data-module/services/http.service';
import { getToken } from 'src/app/dave-data-module/State/selectors/base.selectors';
import {EventDataService} from '../../../../dave-data-module/services/event.service-data-service';
import {
    getConstructionDiariesByCommissionId
} from '../../../../dave-data-module/State/selectors/construction-diary.selectors';

export interface DetailConstructionDiaryEntryComponentDialogData {
    CommissionId: number;
    DiaryDate: Date;
}
export type DetailConstructionDiaryEntryComponentDialogReturnData = undefined | 'open-time-tracking-kagetec';
@Component({
    selector: 'app-detail-construction-diary-entry',
    templateUrl: './detail-construction-diary-entry.component.html',
    styleUrls: ['./detail-construction-diary-entry.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false },
        },
        DatePipe,
    ],
})
export class DetailConstructionDiaryEntryComponent implements OnInit, OnDestroy, AfterViewInit, ComponentCanDeactivate {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '90vw',
        height: '90vh',
        // panelClass: ['custom-dialog-class-without-padding', 'custom-dialog-class-mobile-fullscreen'],
    };
    @ViewChild('matStepper') MatStepper: MatStepper;

    @ViewChild('page1') taskPage: TemplateRef<any>;
    @ViewChild('page2') leistungsPage: TemplateRef<any>;
    @ViewChild('page3') erschwernisEventPage: TemplateRef<any>;
    @ViewChild('page4') zusatzEventPage: TemplateRef<any>;
    @ViewChild('timeTrackingPage') timeTrackingPage: TemplateRef<any>;

    protected commissionId$ = new BehaviorSubject<number>(null);
    @Input() set commissionId(v: number) {
        if (this.commissionId$.value !== v) {
            this.commissionId$.next(v);
        }
    }
    protected diaryDate$ = new BehaviorSubject<Date>(null);
    @Input() set diaryDate(v: Date) {
        if (this.diaryDate$.value?.getTime() !== v?.getTime()) {
            this.diaryDate$.next(v);
        }
    }

    private filePreviewDialog: MatDialogRef<DaveFilePreviewComponent>;

    protected pages$: Observable<Array<TemplateRef<any>>>;
    protected showWeatherOnPage2$: Observable<boolean>;
    public DMSNotMinimalistic = false;
    public FolderTypes = FolderTypes;
    public LeistungsergebnisseUseTemplateMode = false;
    public Diary$: Observable<ConstructionDiaryEntity>;
    protected authorName$: Observable<string>;
    public Folder$: Observable<FolderEntity>;
    protected fileUploadParams$: Observable<fileUploadParamsObj>;
    public Loaded$: Observable<true>;
    public Files$: Observable<FileEntity[]>;
    public Signature$: Observable<FileEntity>;
    public SignatureImage$: Observable<string>;
    public EventsErschwerniss$: Observable<{ type: string; typeId: number; events: MatTableDataSource<DaveListCardcolumnProperties<EventEntity>>; icon: string }[]>;
    public EventsZusatz$: Observable<{ type: string; typeId: number; events: MatTableDataSource<EventEntity>; icon: string }[]>;
    public Tasks$: Observable<DailyTaskType[]>;
    public TaskTableData$: Observable<MatTableDataSource<DaveListCardcolumnProperties<EventEntity & { stateName: string; time: string }>>>;
    private fileDialog: MatDialogRef<any>;
    public PartnerTypeKagetec = PartnerTypeEnum.Kagetec;
    public PartnerTypeId$ = this.store.select(getPartner).pipe(
        map((partner) => {
            return partner?.PartnerTypeId;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public NewTaskForm = this.fb.group({});
    public Form = new FormGroup({
        Weather: new FormControl<string>(''),
        Temperature: new FormControl<number>(null),
        Leistungsergebnisse: new FormControl<string>(''),
        LeistungsergebnisseTemplate: new FormControl<number[]>([]),
        BesondereVorkommnisse: new FormControl<string>(''),
        Leistungsaenderungen: new FormControl<string>(''),
        Bedenken: new FormControl<string>(''),
        MaterialDevices: new FormArray<materialDeviceForm>([]),
        Title: new FormControl<string>(''),
        ExecutingCompany: new FormControl<string>(''),
        MapMarker: new FormControl<MapMarkerFileDictionary>(null),

        TravelZone: new FormControl<number>(null),

        ToolFee: new FormControl<boolean>(false),
        SmallAndSealingMaterial: new FormControl<boolean>(false),
        WorkCompleted: new FormControl<boolean>(false),
    });
    public DMSMeta = DMSPageMeta;

    private routerSubscription: Subscription;
    public IsToday$: Observable<boolean>;
    protected subscriptions: Subscription[] = [];
    public SomeRequiredTaskPending$: Observable<boolean>;
    // i == 0 && !diary.Id && NoInstruction
    public SaveButtonDisabled$: Observable<boolean>;
    public HasInspection$: Observable<boolean>;
    public SelectedIndex: number = 0;
    public CurrentUser$ = this.store.select(getUser);
    protected isLuksch$ = this.store.select(getPartner).pipe(
        map((partner) => partner.Id === window['env']['luksch_partner_id'] || partner.Id === window['env']['luksch_partner_id2']),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected isSteinhoff$ = this.store.select(getPartner).pipe(
        map((partner) => partner.Id === window['env']['steinhoff_partner_id']),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    protected selectedCommissionId$ = new ReplaySubject<number>(1);
    protected commissionPath$: Observable<CommissionEntity[]> = this.commissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap((commissionId) =>
            getFetched$(this.store, getCommissionsFetched, getCommissionDictionary).pipe(
                map((commissions) => {
                    const commissionPaths = [commissions[commissionId]];
                    let i = 0;
                    while (commissionPaths[0]?.ParentId && i < 1000) {
                        i++;
                        commissionPaths.unshift(commissions[commissionPaths[0].ParentId]);
                    }
                    return commissionPaths.filter(isNotNullOrUndefined);
                }),
            ),
        ),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    // protected commissionOrParentId$ = this.isLuksch$.pipe(
    //     switchMap((isLuksch) => (isLuksch ? this.rootCommissionId$ : this.commissionId$)),
    //     distinctUntilChanged(),
    // );
    protected commissionOrParentId$ = this.selectedCommissionId$.asObservable();
    protected commissionOrParent$ = this.commissionOrParentId$.pipe(
        switchMap((id) => this.store.select(getCommissionById({ id }))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    private userToCommissionFromCommission$ = this.commissionOrParent$.pipe(
        switchMap((c) => this.store.select(getUserToCommissions).pipe(map((u2cs) => u2cs.filter((u2c) => u2c.CommissionId === c.Id)))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected assignedPersons$ = this.commissionOrParentId$.pipe(
        switchMap((commissionId) =>
            commissionId
                ? getFetched$(this.store, getPerson2EntitiesFetched, getPerson2EntityByCommissionId({ commissionId }), this.personToEntityResolver).pipe(
                      switchMap((p2e) =>
                          p2e.length ? getFetched$(this.store, getPersonsFetched, getPersonDictionary, this.personResolver).pipe(map((persons) => uniqArray(p2e.map((p) => p.PersonId)).map((personId) => persons[personId]))) : of([]),
                      ),
                  )
                : of([]),
        ),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    public ShowSelectedUsers$ = combineLatest([this.store.select(getEmployeesSortedByNameStartWithMe), this.commissionOrParent$, this.store.select(getEntityRole), this.userToCommissionFromCommission$]).pipe(
        map(([employees, commission, er, u2c]) => {
            return employees
                .filter((e) => u2c.some((u) => u.UserId === e.UserId))
                .map((e) => {
                    return {
                        User: e,
                        Assignee: u2c.some((u) => u.UserId === e.UserId && u.Assignee),
                        roles: u2c
                            .filter((u2) => u2.UserId === e.UserId && commission.Id === u2.CommissionId)
                            .map((item) => {
                                return er?.find((x) => x?.Id === item?.RoleId)?.DisplayName;
                            }),
                    };
                });
        }),
    );

    protected leistungsergebnisseLabel$ = combineLatest([this.isSteinhoff$, this.isLuksch$]).pipe(
        map(([isSteinhoff, isLuksch]) => {
            if (isLuksch) {
                return 'Arbeitsbeschreibung';
            } else if (isSteinhoff) {
                return 'Textliche Beschreibung';
            }
            return 'Leistungsergebnisse';
        }),
    );
    protected showBesondereVorkommnisseForm$ = combineLatest([this.isSteinhoff$, this.isLuksch$]).pipe(map(([isSteinhoff, isLuksch]) => !(isLuksch || isSteinhoff)));
    protected showLeistungsaenderungenForm$ = combineLatest([this.isSteinhoff$, this.isLuksch$]).pipe(map(([isSteinhoff, isLuksch]) => !(isLuksch || isSteinhoff)));
    protected showPlans$ = this.isSteinhoff$;
    protected showAuthor$ = this.isSteinhoff$;
    protected showExecutingCompany$ = this.isSteinhoff$;
    protected showTitle$ = this.isSteinhoff$;
    protected generatedDocumentForDiary$: Observable<{ found: GeneratedDocumentsEntity }>;
    protected diaryGeneratedDocumentId$: Observable<number>;
    private genDocCreated$ = new Subject<number>();

    constructor(
        private constructionDiaryDataService: ConstructionDiaryDataService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        DialogData: DetailConstructionDiaryEntryComponentDialogData,
        public LS: LoadingService,
        private store: Store<State>,
        private fb: UntypedFormBuilder,
        private actions$: Actions,
        public dialogRef: MatDialogRef<DetailConstructionDiaryEntryComponent, DetailConstructionDiaryEntryComponentDialogReturnData>,
        private router: Router,
        private datePipe: DatePipe,
        commissionResolver: CommissionResolver,
        commissionTypeResolver: CommissionTypeResolver,
        eventTypeResolver: EventTypeResolver,
        private personToEntityResolver: Person2EntityResolver,
        travelZoneResolver: TravelZoneResolver,
        private fileDataService: FileDataService,
        private generatedDocumentsTypesResolver: GeneratedDocumentsTypeResolver,
        protected addReportService: AddReportService,
        private generatedDocsRes: GeneratedDocumentsResolver,
        private folderDataService: FolderDataService,
        protected cls: CustomLabelService,
        private toastrService: ToastrService,
        private personResolver: PersonResolver,
        person2EntityResolver: Person2EntityResolver,
        complaintTypeResolver: ComplaintTypeResolver,
        workedTimesResolver: WorkedTimesResolver,
        workDayResolver: WorkDayResolver,
        public Api: HttpService,
        protected eventDataService: EventDataService,
    ) {
        firstValueFrom(store.select(getCommissionTypesFetched)).then((fetched) => {
            if (!fetched) {
                commissionTypeResolver.resolve();
            }
        });
        eventTypeResolver.resolve();
        commissionResolver.resolve();
       // constructionDiaryResolver.resolve();

        person2EntityResolver.resolve();
        complaintTypeResolver.resolve();
        personResolver.resolve();
        workedTimesResolver.resolve();
        workDayResolver.resolve();
        travelZoneResolver.resolve();

        if (DialogData?.CommissionId) {
            this.commissionId = DialogData.CommissionId;
            ConstructionDiaryByCommissionIdResolverWithoutRoute(this.store, DialogData.CommissionId).subscribe()
        }
        if (DialogData?.DiaryDate) {
            this.diaryDate = DialogData.DiaryDate;
        }

        this.HasInspection$ = combineLatest([getFetched$(store, getGeneratedDocumentsFetched, getGeneratedDocuments, generatedDocsRes), this.commissionOrParentId$]).pipe(
            map(([docs, commissionId]) => docs.some((d) => d.AdditionalData?.ConstructionDiary?.CommissionInspectionId === commissionId)),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.SaveButtonDisabled$ = this.PartnerTypeId$.pipe(switchMap((pTId) => (pTId === PartnerTypeEnum.Kagetec ? this.HasInspection$.pipe(map((hasInspection) => !hasInspection)) : of(false))));
        firstValueFrom(this.commissionPath$).then((path) => {
            this.selectedCommissionId$.next(path[path.length - 1].Id);
        });
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
        this.routerSubscription?.unsubscribe();
    }
    getFileUploadParams(folder: FolderEntity): fileUploadParamsObj {
        const ret: fileUploadParamsObj = { folder_id: folder.Id.toString() };

        if (folder.Type === FolderTypes.construction_diary) {
            const metaData = {};
            metaData['constructionDiaryIds'] = [folder.EntityId];
            ret.metadata = JSON.stringify(metaData);
        }
        return ret;
    }

    ngOnInit(): void {
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: RouterEvent) => event instanceof NavigationStart),
                filter(() => !!this.dialogRef),
            )
            .subscribe(() => {
                this.dialogRef.close();
            });

        this.Diary$ = combineLatest([this.commissionOrParentId$, this.diaryDate$,
        ]).pipe(
            switchMap(([commissionOrParentId, diaryDate]) =>
                this.store.select(
                    getConstructionDiariesByCommissionId(commissionOrParentId)
                ).pipe(
                    switchMap((diaries) => {
                        {
                            const diary = diaries.find((d) =>  sameDay(d.Date, diaryDate));
                            if (diary) {
                                return of(diary);
                            } else {
                                return getFetched$(this.store, getCommissionsFetched, getCommissionById({ id: commissionOrParentId })).pipe(
                                    first(),
                                    map((commissionOrParent) =>
                                        new ConstructionDiaryEntity().Clone({
                                            CommissionId: commissionOrParentId,
                                            Date: diaryDate,
                                            Status: ConstructionDiaryStatusEnum.Newly,
                                            TravelZoneId: commissionOrParent?.TravelZoneId,
                                        }),
                                    ),
                                );
                            }
                        }
                    })
                    )
                ),
            tap((diary) => {
                this.Form.controls.MaterialDevices.clear();
                const materialDevices = diary.getMaterialDevices();
                materialDevices.forEach((device) => this.Form.controls.MaterialDevices.push(createMaterialDeviceForm(device)));
                this.Form.reset({
                    Weather: diary.AdditionalData?.weather?.description || '',
                    Leistungsergebnisse: diary.Leistungsergebnisse || '',
                    LeistungsergebnisseTemplate: diary.AdditionalData?.leistungsergebnisseTemplateIds || [],
                    Temperature: diary.AdditionalData?.weather?.temp || null,
                    BesondereVorkommnisse: diary.BesondereVorkommnisse || '',
                    Leistungsaenderungen: diary.Leistungsaenderungen || '',
                    Bedenken: diary.Bedenken || '',
                    MaterialDevices: materialDevices,
                    Title: diary.Title,
                    ExecutingCompany: diary.ExecutingCompany,
                    MapMarker: diary.AdditionalData?.mapMarker || {},
                    TravelZone: diary.TravelZoneId,
                    ToolFee: !!diary.AdditionalData?.toolFee,
                    SmallAndSealingMaterial: !!diary.AdditionalData?.smallAndSealingMaterial,
                    WorkCompleted: !!diary.AdditionalData?.workCompleted,
                });
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.authorName$ = this.Diary$.pipe(
            map((d) => d?.UserId),
            distinctUntilChanged(),
            switchMap((userId) => (userId ? this.store.select(getUserById({ id: userId })).pipe(map((u) => u?.DisplayName)) : of(''))),
        );
        this.diaryGeneratedDocumentId$ = merge(this.Diary$.pipe(map((d) => d?.GeneratedFileId)), this.genDocCreated$).pipe(shareReplay({ refCount: true, bufferSize: 1 }));
        this.generatedDocumentForDiary$ = this.diaryGeneratedDocumentId$.pipe(
            distinctUntilChanged(),
            switchMap((generatedDocumentId) => (generatedDocumentId ? getFetched$(this.store, getGeneratedDocumentsFetched, getGeneratedDocumentById({ id: generatedDocumentId }), this.generatedDocsRes) : of(null))),
            map((doc) => ({ found: doc })), // if deleted found is undefined
        );
        this.Folder$ = this.Diary$.pipe(
            filter((d) => d && !!d.Id),
            switchMap((diary) =>
                this.folderDataService.getFolderFromEntity(diary.Id, FolderTypes.construction_diary).pipe(switchMap(() => this.store.select(getFolderByEntity({ entityId: diary.Id, type: FolderTypes.construction_diary })))),
            ),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.fileUploadParams$ = this.Folder$.pipe(map((folder) => (folder ? this.getFileUploadParams(folder) : null)));
        this.IsToday$ = this.Diary$.pipe(map((diary) => sameDay(diary.Date, new Date())));

        this.Loaded$ = combineLatest([
           // this.store.select(getConstructionDiariesFetched).pipe(filter((v) => !!v)),
            of(true),
            this.store.select(getCommissions).pipe(filter(isNotNullOrUndefined)),
            this.store.select(getEventTypes).pipe(filter(isNotNullOrUndefined)),
        ]).pipe(map(() => true));
        this.Files$ = this.Folder$.pipe(switchMap((folder) => (folder ? this.fileDataService.GetFilesStateFromFolder$(folder.Id).pipe(map((files) => files.filter((f) => !f.Hidden))) : of([]))));
        this.Signature$ = this.Diary$.pipe(
            filter((d) => d && !!d.Id),
            switchMap((diary) => diary?.SignatureFileId ? this.fileDataService.GetFileById$(diary.SignatureFileId) : of(null)),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.SignatureImage$ = combineLatest([this.store.select(getToken), this.Signature$]).pipe(
            filter((v) => v.every(isNotNullOrUndefined)),
            map(([token, signature]) => this.Api.GetUrl(signature.GetLastVersion().GetDownloadLink(token), 'file')),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        const diaryEvents$ = combineLatest([
            this.Diary$,
            this.commissionId$.pipe(
                filter(isNotNullOrUndefined),
                switchMap(id => this.eventDataService.GetFromCommissionEvents$(id))
            )
            // this.store.select(getEvents)
        ]).pipe(
            map(([diary, events]) => (diary?.EventIds ? events?.filter((e) => diary?.EventIds.includes(e.Id)) : [])),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.EventsErschwerniss$ = combineLatest([this.store.select(getEventTypes).pipe(filter(isNotNullOrUndefined)), diaryEvents$, this.isSteinhoff$, this.isLuksch$]).pipe(
            map(([eventTypes, diaryEvents, isSteinhoff, isLuksch]) => {
                if (isSteinhoff) {
                    const auffaeligkeitenType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Auffaeligkeit);

                    return [
                        {
                            type: 'Auffälligkeiten',
                            typeId: auffaeligkeitenType.Id,
                            icon: auffaeligkeitenType.ImagePath,
                            events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === auffaeligkeitenType.Id)),
                        },
                    ];
                }
                const ret: {
                    type: string;
                    typeId: number;
                    icon: string;
                    events: MatTableDataSource<EventEntity>;
                }[] = [];
                if (isLuksch) {
                    const docuType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Dokumentation);
                    ret.push({
                        type: 'Dokumentationen',
                        typeId: docuType.Id,
                        icon: docuType.ImagePath,
                        events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === docuType.Id)),
                    });
                }
                const mangelType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Erschwernis);
                const mangelanzeigeType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Mangelanzeige);
                const bedenkenanzeigeType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Bedenkenanzeige);
                ret.push(
                    {
                        type: 'Erschwernisse',
                        typeId: mangelType.Id,
                        icon: mangelType.ImagePath,
                        events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === mangelType.Id)),
                    },
                    {
                        type: 'Mängelanzeigen',
                        typeId: mangelanzeigeType.Id,
                        icon: mangelanzeigeType.ImagePath,
                        events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === mangelanzeigeType.Id)),
                    },
                    {
                        type: 'Bedenkenanzeigen',
                        typeId: bedenkenanzeigeType.Id,
                        icon: bedenkenanzeigeType.ImagePath,
                        events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === bedenkenanzeigeType.Id)),
                    },
                );
                return ret;
            }),
        );
        this.EventsZusatz$ = combineLatest([this.store.select(getEventTypes).pipe(filter(isNotNullOrUndefined)), diaryEvents$, this.isSteinhoff$, this.isLuksch$]).pipe(
            map(([eventTypes, diaryEvents, isSteinhoff, isLuksch]) => {
                if (isSteinhoff) {
                    const mangelanzeigeType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Mangelanzeige);

                    return [
                        {
                            type: 'Mängelanzeigen',
                            typeId: mangelanzeigeType.Id,
                            icon: mangelanzeigeType.ImagePath,
                            events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === mangelanzeigeType.Id)),
                        },
                    ];
                }
                const nachnahmeType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Zusatzarbeit);
                const ret = [
                    {
                        type: 'Zusatzarbeiten',
                        typeId: nachnahmeType.Id,
                        icon: nachnahmeType.ImagePath,
                        events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === nachnahmeType.Id)),
                    },
                ];
                if (isLuksch) {
                    const regiearbeitenType = eventTypes.find((e) => e.Name === EventTypeNamesEnum.Regiearbeit);
                    if (regiearbeitenType) {
                        ret.push({
                            type: 'Regiearbeiten',
                            typeId: regiearbeitenType.Id,
                            icon: regiearbeitenType.ImagePath,
                            events: new MatTableDataSource(diaryEvents.filter((e) => e.EventTypeId === regiearbeitenType.Id)),
                        });
                    }
                }
                return ret;
            }),
        );
        this.Tasks$ = this.Diary$.pipe(
            switchMap((diary) => {
                if (diary.Id) {
                    return combineLatest([
                        this.Diary$,
                        this.commissionId$.pipe(switchMap(id => this.eventDataService.GetFromCommission$(id).pipe(map(this.eventDataService.FilterDailyToDo))))
                        // this.store.select(getDailyToDos)
                    ]).pipe(map(([diary, events]) => (diary?.EventIds ? events?.filter((e) => diary?.EventIds.includes(e.Id)) : [])));
                } else {
                    return combineLatest([this.store.select(getCommissionTypes).pipe(filter(isNotNullOrUndefined)), this.store.select(getCommissionById({ id: diary.CommissionId }))]).pipe(
                        switchMap(([cts, commission]) => {
                            this.NewTaskForm = this.fb.group({});
                            const dayliTodos = cts?.find((ct) => ct.Id === commission?.CommissionTypeId)?.AdditionalData?.ConstructionDiary.dailyTodos || [];
                            dayliTodos.forEach((d) => this.NewTaskForm.addControl(d.unicId + '', new UntypedFormControl(EventStateEnum.New)));
                            return this.NewTaskForm.valueChanges.pipe(
                                startWith(''),
                                map((v) => {
                                    return dayliTodos.map((dailyTodo) => {
                                        const date = new Date(FrontendDate(diary.Date, true));
                                        date.setHours(dailyTodo.time.hour);
                                        date.setMinutes(dailyTodo.time.minute);

                                        return new EventEntity().Clone({
                                            Name: dailyTodo.name,
                                            State: v ? v[dailyTodo.unicId] : EventStateEnum.New,
                                            AdditionalData: { ...dailyTodo.additionalData, UnicId: dailyTodo.unicId },
                                            EventDate: date,
                                        });
                                    });
                                }),
                            );
                        }),
                    );
                }
            }),
            withLatestFrom(this.Diary$),
            map(([tasks, diary]) => {
                const now = moment();
                return tasks.map((t) => {
                    return Object.assign(t.Clone(), {
                        stateName: EventStateEnumNameMap.get(t.State),
                        time: this.datePipe.transform(t.EventDate, 'shortTime'),
                        suffixButton: {
                            icon: t.State === EventStateEnum.Done ? 'clipboard-check' : 'clipboard',
                            tooltip: t.State === EventStateEnum.Done ? 'Zurücksetzen' : 'Erledigt',
                            disabled: t.AdditionalData?.preventEarlyExecution && now.isBefore(t.EventDate) ? true : false,
                            disabledTooltip: 'ab ' + this.datePipe.transform(t.EventDate, 'shortTime') + ' verfügbar',
                            onClick: (task) => {
                                if (task.Id) {
                                    const allOthersDone = tasks.filter((t) => t.Id !== task.Id).every((t) => t.State === EventStateEnum.Done);
                                    if (task.State !== EventStateEnum.Done && allOthersDone && (diary.Leistungsergebnisse || diary.AdditionalData?.leistungsergebnisseTemplateIds?.length)) {
                                        this.store.dispatch(
                                            ConstructionDiaryActionTypes.Modify({
                                                Payload: { ...this.getModifyActionPayload(diary), id: diary.Id, status: ConstructionDiaryStatusEnum.Done },
                                            }),
                                        );
                                    } else if (diary.Status === ConstructionDiaryStatusEnum.Done) {
                                        this.store.dispatch(
                                            ConstructionDiaryActionTypes.Modify({
                                                Payload: { ...this.getModifyActionPayload(diary), id: diary.Id, status: ConstructionDiaryStatusEnum.Newly },
                                            }),
                                        );
                                    }
                                    this.store.dispatch(
                                        EventsActionTypes.ModifyEvent({
                                            Payload: {
                                                id: task.Id,
                                                state: task.State === EventStateEnum.Done ? EventStateEnum.New : EventStateEnum.Done,
                                            },
                                        }),
                                    );
                                } else {
                                    this.NewTaskForm.get(task.AdditionalData.UnicId + '').setValue(task.State === EventStateEnum.Done ? EventStateEnum.New : EventStateEnum.Done);
                                }

                                if (task.State !== EventStateEnum.Done && task.AdditionalData?.kagetecImage) {
                                    this.PartnerTypeId$.pipe(first()).subscribe((pId) => {
                                        if (pId === PartnerTypeEnum.Kagetec) {
                                            this.dialog.open<ShowImageComponent, ShowImageComponentDialogData>(ShowImageComponent, {
                                                data: {
                                                    ShowCloseButton: true,
                                                    Url: '/assets/kagetec/' + task.AdditionalData?.kagetecImage + '.jpg',
                                                },
                                                // minWidth: '50vw',
                                                maxHeight: '100vh',
                                                panelClass: 'custom-dialog-class-mobile-fullscreen',
                                                closeOnNavigation: false,
                                            });
                                        }
                                    });
                                }
                            },
                        } as ButtonConfig<DailyTaskType>,
                    });
                });
            }),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );
        this.TaskTableData$ = this.Tasks$.pipe(map((v) => new MatTableDataSource(v)));
        this.SomeRequiredTaskPending$ = this.Tasks$.pipe(map((tasks) => tasks?.some((t) => t.State !== EventStateEnum.Done && t.AdditionalData?.isRequiredToComplete)));
    }

    private saveInProgress = false
    public async Save($event?: StepperSelectionEvent, isLastStep?: boolean) {
        this.saveInProgress = true;
        const tasks = await firstValueFrom(this.Tasks$);

        if ($event || isLastStep) {
            tasks.filter((t) => t.State !== EventStateEnum.Done && t.AdditionalData?.autoCompleteOnStepSave && (isLastStep || t.AdditionalData.autoCompleteOnStepSave < $event.selectedIndex + 1)).forEach((t) => t.suffixButton.onClick(t));
        }
        if (this.LS.isLoading) {
            return;
        }
        const diary = await firstValueFrom(this.Diary$);
        const commissionId = await firstValueFrom(this.commissionOrParentId$);
        const values: DaveMutationCreateConstructionDiaryArgs = {
            ...this.getModifyActionPayload(diary),
        };
        // D277-5067
        // if (this.Form.value.WorkCompleted) {
        //     firstValueFrom(
        //         combineLatest([
        //             getFetched$(this.store, getCommissionsFetched, getCommissionById({ id: commissionId })),
        //             getFetched$(this.store, getStatusFromBackofficeFetched, getStatusFromBackofficeDictionary, this.statusBackofficeResolver),
        //         ]),
        //     ).then(([commission, statusBackoffices]) => {
        //         if (!commission.StatusBackofficeId || !statusBackoffices[commission.StatusBackofficeId]?.IsCompleted) {
        //             this.store.dispatch(
        //                 CommissionActionTypes.ModifyCommission({
        //                     Payload: {
        //                         id: commission.Id,
        //                         statusBackofficeId: Object.values(statusBackoffices)
        //                             .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
        //                             .find((s) => s.IsCompleted)?.Id,
        //                     },
        //                 }),
        //             );
        //         }
        //     });
        // }

        await this.constructionDiaryDataService.saveDiaryEntry(diary, tasks, values, commissionId);
        this.saveInProgress = false;
    }
    public AddEvent(eventTypeId: number, diary: ConstructionDiaryEntity, eventTypeName: string) {
        this.dialog
            .open<AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn>(AddEventDialogComponent, {
                data: {
                    eventTypeId: eventTypeId,
                    headline: eventTypeName,
                    hideDate: true,
                    diary: diary,
                    commissionId: diary.CommissionId,
                    newEvent: true,
                },
                ...AddEventDialogComponent.DefaultConfig,
            })
            .afterClosed();
    }

    public GetStatusName = (diary: ConstructionDiaryEntity) => ConstructionDiaryStatusEnumNameMap.get(diary.Status);

    public CloseSideDialog() {
        if (this.fileDialog?.getState() === MatDialogState.OPEN) {
            this.fileDialog.close();
        }
    }
    public OpenFileUpload(CommissionId: number) {
        combineLatest([this.Files$, this.folderDataService.getFolderFromEntity(CommissionId, FolderTypes.commission)])
            .pipe(take(1))
            .subscribe(([files, folder]) => {
                this.CloseSideDialog();
                this.fileDialog = this.dialog.open<DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData>(DaveSelectFileFromDmsComponent, {
                    ...DaveSelectFileFromDmsComponent.DefaultConfig,
                    data: {
                        moveWarning: '',
                        folderId: folder?.Id,
                        preSelectedFiles: [...files.map((f) => f.Id)],
                    },
                });
                this.fileDialog
                    .afterClosed()
                    .pipe(
                        take(1),
                        filter((v) => !!v),
                        withLatestFrom(this.store.select(getFiles), this.Diary$),
                        tap(([{ documents }, allfiles, diary]) => {
                            if (documents) {
                                const selectedFiles = allfiles.filter((f) => documents.includes(f.Id));
                                const filesToSet = selectedFiles.filter((f) => !f.MetaData?.constructionDiaryIds?.includes(f.Id));
                                const filesToUnSet = files.filter((f) => !documents.includes(f.Id));
                                filesToSet.forEach((f) => {
                                    const additionaldata: FileMetaData = { ...f.MetaData };
                                    additionaldata.constructionDiaryIds = additionaldata.constructionDiaryIds ? [...additionaldata.constructionDiaryIds, diary.Id] : [diary.Id];
                                    this.store.dispatch(
                                        // FilesActionTypes.ModifyFileRequest({
                                        //     Payload: { DocumentId: f.Id.toString(), AutoSetFolder: true, ConstructionDiaryId: diary.Id.toString(), Metadata: JSON.stringify(additionaldata) },
                                        // }),
                                        FilesActionTypes.CreateLinkRequest({
                                            Payload: { DocumentId: f.Id.toString(), AutoSetFolder: true, ConstructionDiaryId: diary.Id.toString(), Metadata: JSON.stringify(additionaldata) },
                                        }),
                                    );
                                });
                                filesToUnSet.forEach((f) => this.UnsetFile(f, diary.Id));
                            }
                        }),
                    )
                    .subscribe();
            });
    }
    public OpenEditEventDialog(event: EventEntity) {
        let userId: number;
        let deletePermission: boolean = false;
        this.CurrentUser$.pipe(take(1)).subscribe((user) => {
            userId = user.Id;
        });
        if (event.UserId === userId) {
            deletePermission = true;
        } else {
            this.ShowSelectedUsers$.pipe(take(1)).subscribe((user) => {
                let permission = user.filter((u) => u.User.UserId === userId && (u.roles.includes(String(EntityRoleSlugEnum.Admin)) || u.roles.includes(String(EntityRoleSlugEnum.Projektleiter))) && isNotNullOrUndefined);
                if (permission.length > 0) {
                    deletePermission = true;
                }
            });
        }
        this.dialog.open<AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn>(AddEventDialogComponent, {
            data: {
                eventId: event.Id,
                canDelete: deletePermission,
                eventTypeId: event.EventTypeId,
            },
            ...AddEventDialogComponent.DefaultConfig,
        });
    }
    public UnsetFile(file: FileEntity, diaryId: number) {
        const additionaldata: FileMetaData = { ...file.MetaData };
        additionaldata.constructionDiaryIds = additionaldata.constructionDiaryIds ? additionaldata.constructionDiaryIds.filter((id) => id !== diaryId) : [];
        this.store.dispatch(FilesActionTypes.ModifyFileRequest({ Payload: { DocumentId: file.Id.toString(), Metadata: JSON.stringify(additionaldata) } }));
    }
    private getModifyActionPayload(diary: ConstructionDiaryEntity) {
        const addData: ConstructionDiaryEntityAdditionalData = {
            ...(diary.AdditionalData || {}),
            weather: { description: this.Form.value.Weather, temp: this.Form.value.Temperature },
            leistungsergebnisseTemplateIds: this.LeistungsergebnisseUseTemplateMode ? this.Form.value.LeistungsergebnisseTemplate : null,
            mapMarker: this.Form.controls.MapMarker.value || {},
            toolFee: this.Form.controls.ToolFee.value,
            smallAndSealingMaterial: this.Form.controls.SmallAndSealingMaterial.value,
            workCompleted: this.Form.controls.WorkCompleted.value,
        };
        const values: DaveMutationCreateConstructionDiaryArgs = {
            leistungsergebnisse: this.LeistungsergebnisseUseTemplateMode ? null : this.Form.value.Leistungsergebnisse,
            additionalData: JSON.stringify(addData),
            leistungsaenderungen: this.Form.value.Leistungsaenderungen,
            bedenken: this.Form.value.Bedenken,
            besondereVorkommnisse: this.Form.value.BesondereVorkommnisse,
            commissionId: diary.CommissionId,
            materialDeviceAsString: JSON.stringify(this.Form.value.MaterialDevices),
            executingCompany: this.Form.value.ExecutingCompany,
            title: this.Form.value.Title,
            travelZoneId: this.Form.value.TravelZone,
            automaticConstructionDiaryNumber: true,
        };
        return values;
    }
    public onOpenInspection() {
        firstValueFrom(combineLatest([this.store.select(getGeneratedDocuments), this.Diary$, this.commissionOrParentId$])).then(([documents, diary, commissionId]) => {
            const doc = documents.find((d) => d.CommissionId === commissionId && d.AdditionalData?.ConstructionDiary?.CommissionInspectionId === commissionId);
            if (doc) {
                this.routeToGenDoc(doc.Id);
            } else {
                firstValueFrom(
                    this.store.select(getGeneratedDocumentsTypesFetched).pipe(
                        tap((fetched) => {
                            if (!fetched) {
                                this.generatedDocumentsTypesResolver.resolve();
                                this.LS.startLoading('resolveGeneratedDocTypes');
                            }
                        }),
                        filter((fetched) => fetched),
                        tap(() => this.LS.endLoading('resolveGeneratedDocTypes')),
                        switchMap(() => this.store.select(getGeneratedDocumentsTypes)),
                    ),
                ).then((types) => {
                    const inspectionType = types.find((t) => t.Slug === GeneratedDocumentsTypeSlugs.kagetecInspection);
                    const addionalData: GeneratedDocumentsEntityAdditionalData = {
                        ConstructionDiary: { CommissionInspectionId: commissionId },
                        CustomFieldsModalTemplates: inspectionType.AdditionalData.CustomFieldsModalTemplates,
                    };

                    this.addReportService
                        .NewReport(inspectionType, null, diary.CommissionId, { name: formatDate(diary.Date, 'yyyy-MM-dd', 'de-DE') + '-Inspektionsformular', commissionId: diary.CommissionId, additionalData: JSON.stringify(addionalData) })
                        .then((action) => {
                            if (action.type === GeneratedDocumentsActionTypes.UpdateOne.type) {
                                this.routeToGenDoc(action.Payload.Id);
                            }
                        });
                });
            }
        });
    }
    private routeToGenDoc(id: number) {
        this.dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
            ...DocumentEditorDialogComponent.DefaultConfig,
            data: {
                generatedDocumentId: id,
            },
        });
    }
    public onStepSelectionChange(event: StepperSelectionEvent) {
        console.log(event);
        this.SelectedIndex = event.selectedIndex;
        this.Save(event);
    }
    ngAfterViewInit() {
        this.pages$ = combineLatest([this.isSteinhoff$, this.isLuksch$]).pipe(
            map(([isSteinhoff, isLuksch]) => {
                if (isLuksch) {
                    return [this.leistungsPage, this.erschwernisEventPage, this.zusatzEventPage, this.timeTrackingPage];
                } else if (isSteinhoff) {
                    return [this.leistungsPage, this.erschwernisEventPage, this.zusatzEventPage];
                }
                return [this.taskPage, this.leistungsPage, this.erschwernisEventPage, this.zusatzEventPage];
            }),
        );
        this.showWeatherOnPage2$ = this.pages$.pipe(map((pages) => !pages.includes(this.taskPage)));
    }

    protected readonly UserAdministrationMeta = UserAdministrationMeta;
    protected readonly GeneratedDocumentsPageMeta = GeneratedDocumentsPageMeta;
    defaultMarker: Pick<MapMarker, 'color'> = {
        color: 'grey',
    };

    openFileDialog(fileId: number) {
        if (this.filePreviewDialog?.getState() === MatDialogState.OPEN) {
            this.filePreviewDialog.close();
        }
        this.filePreviewDialog = this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
            ...DaveFilePreviewComponent.DefaultConfig,
            data: {
                fileId,
            },
        });
    }

    openGeneratedDocumentDialog(generatedDocumentId: number) {
        this.dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
            ...DocumentEditorDialogComponent.DefaultConfig,
            data: {
                generatedDocumentId,
            },
        });
    }

    async createExport() {
        await this.Save(); // for values from same page to be set.
        const CommissionId = await firstValueFrom(this.commissionOrParentId$);
        const DateFormDefaultValue = new Date(this.diaryDate$.value);
        DateFormDefaultValue.setHours(0, 0, 0, 0);
        const ToDateFormDefaultValue = new Date(DateFormDefaultValue);
        this.dialog
            .open<SelectDiaryTimespanDialogComponent, SelectDiaryTimespanDialogComponentDialogData, SelectDiaryTimespanDialogComponentDialogReturnData>(SelectDiaryTimespanDialogComponent, {
                ...SelectDiaryTimespanDialogComponent.DefaultConfig,
                data: {
                    CommissionId,
                    DiaryType: GeneratedDocumentsTypeSlugs.constructionDiary,
                    DateFormDefaultValue,
                    ToDateFormDefaultValue,
                },
            })
            .afterClosed()
            .subscribe((res) => {
                if (res?.length === 1) {
                    this.genDocCreated$.next(res[0].id);
                    this.openGeneratedDocumentDialog(res[0].id);
                }
            });
    }

    async createDiaryIfFolderIsNeeded() {
        // fix für keinen ordner für den fileexplorer
        const pages = await firstValueFrom(this.pages$);
        const diary = await firstValueFrom(this.Diary$);
        const hasFileExplorerOnCurrentPage = pages[this.MatStepper.selectedIndex] === this.leistungsPage;
        if (hasFileExplorerOnCurrentPage && !diary?.Id && !this.saveInProgress) {
            this.Save(null, false);
        }
    }

    async onSelectedTabChange() {
        await this.createDiaryIfFolderIsNeeded();
    }

    onMapMarkerChange($event: MapMarkerFileDictionary) {
        console.log('onMapMarkerChange', $event);
        this.Form.controls.MapMarker.setValue($event);
        this.Form.controls.MapMarker.markAsDirty();
    }

    async onScreenshotTaken(file: Blob) {
        const uploadParams = await firstValueFrom(this.fileUploadParams$);

        const clonedMap: FileUploadParams = new Map(Object.entries(uploadParams) as [keyof fileUploadParamsObj, string][]);
        clonedMap.set('name', PLAN_FILE_PREFIX_FOR_SFDT_TEMPLATES + '-' + moment().format('DD-MM-YYYY'));
        this.store.dispatch(
            FilesActionTypes.UploadFileBackendRequest({
                Payload: {
                    file: file,
                    params: clonedMap,
                },
            }),
        );
        const action = await firstValueFrom(this.actions$.pipe(ofType(FilesActionTypes.UploadFileBackendFailure, FilesActionTypes.UploadFileBackendSuccess)));
        if (action.type === FilesActionTypes.UploadFileBackendSuccess.type) {
            this.toastrService.success(action.Payload.Name + ' erfolgreich gespeichert', 'Screenshot gespeichert');
        } else {
            this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Screenshot speichern fehlgeschlagen' } }));
        }
    }

    async onAddAssignedPersons() {
        const persons = await firstValueFrom(this.assignedPersons$);
        const personIds = persons.map((p) => p.Id);
        this.dialog
            .open<SelectPersonsComponent, SelectPersonsComponentDialogData, SelectPersonsComponentDialogReturnData>(SelectPersonsComponent, {
                ...SelectPersonsComponent.DefaultConfig,
                data: {
                    // ButtonText: 'test',
                    SelectedPersonIds: [],
                    personFilter: (p) => personIds.includes(p.Id) && !p.Deleted,
                },
            })
            .afterClosed()
            .subscribe((ret) => {
                if (ret?.length) {
                    this.Form.controls.ExecutingCompany.setValue([this.Form.value.ExecutingCompany, ...ret.map((p) => p.DisplayName)].filter((v) => !!v).join(', '));
                }
            });
    }
    // @HostListener('window:beforeunload')
    // tslint:disable-next-line:naming-convention
    canDeactivate(): boolean {
        return !this.Form.dirty;
    }

    selectCommissionId(Id: number) {
        if (this.canDeactivate() || confirm(PENDING_CHANGES_DEFAULT_MESSAGE)) {
            this.selectedCommissionId$.next(Id);
            setTimeout(()=> this.createDiaryIfFolderIsNeeded(), 10);
        }
    }
}
